export const getErrorMessage = (error: unknown): string => {
  if (typeof error === "object" && error !== null && "message" in error) {
    return (error as { message: string }).message;
  }

  if (error instanceof Error) {
    return error.message;
  }

  if (typeof error === "string") {
    return error;
  }

  return "An unexpected error occurred.";
};

export const getErrorCode = (error: unknown): string => {
  if (typeof error === "object" && error !== null && "code" in error) {
    return (error as { code: string }).code;
  }

  if (error instanceof Error) {
    return error.message;
  }

  if (typeof error === "string") {
    return error;
  }

  return "An unexpected error occurred.";
};

// Maps a Firebase error code to an i18n key. Covers Firebase Auth codes
// (auth/*) and the Firestore status codes that surface in the same flows
// (e.g. "unavailable" when a getDoc call happens offline), so callers can
// translate failures uniformly regardless of which SDK threw.
// Returns the key (not the translated string) so the caller still owns t().
// Unknown codes fall through to UNEXPECTED_ERROR — never leak the raw code.
export const mapAuthErrorCode = (code: string): string => {
  switch (code) {
    case "auth/invalid-email":
    case "auth/user-not-found":
    case "auth/wrong-password":
    case "auth/invalid-credential":
      return "INVALID_CREDENTIALS";
    case "auth/network-request-failed":
    case "unavailable":
    case "deadline-exceeded":
      return "NETWORK_ERROR";
    case "auth/too-many-requests":
      return "TOO_MANY_LOGIN_ATTEMPTS";
    case "auth/user-disabled":
      return "ACCOUNT_DISABLED";
    default:
      return "UNEXPECTED_ERROR";
  }
};
